import menuIcon from "../images/FKC-background-red.png"
import panIcon from "../images/panIcon.png"
import cartIcon from "../images/cartIcon.png"
import calendarIcon from "../images/calendarIcon.png"
import stockIcon from "../images/stockIcon.png"
export default function Navbar({modeName,handleNavigate}){
  const today = new Date()
  return(
    <nav className="navbar">
      <div className="navbar--logo">
        <img src={menuIcon} className="navbar--menuIcon"/>
        <h4 className="navbar--title">
          {modeName}
        </h4>
      </div>
      <div className="navbar--navigation">
        <img className="navbar--cart" src={cartIcon} onClick={() => handleNavigate(0)}/>
        <img className="navbar--pan" src={panIcon} onClick={() => handleNavigate(1)}/>
        <div className="navbar--calendar">
          <img className="navbar--calendarIcon" src={calendarIcon} onClick={() => handleNavigate(2)}/>
          <div className="navbar--date" onClick={() => handleNavigate(2)}>{today.getDate()}</div>
        </div>
        <img className="navbar--stockIcon" src={stockIcon} onClick={() => handleNavigate(3)}/>
      </div>
    </nav>
  )
}